import * as angular from "angular";
import template from "./business-customer-new-transaction-modal.html";
import "./business-customer-new-transaction-modal.less";
import { EVENT_LOGOUT } from "../../constants";
import swal from "sweetalert2";
import { isStringNullishOrEmpty } from "../../services/string-service";
import {
	FORM_BUSINESS_CHARGES,
	FORM_BUSINESS_PRODUCTS
} from "../../routes";

export function controller(loadingService, eventBus, $scope, $logger, uiHelpers, api, appState) {
	const ctrl = this;

	ctrl.$onDestroy = ctrl.cancel;
	ctrl.runOnReady = [];

	ctrl.$onInit = () => {
		eventBus.register(EVENT_LOGOUT, () => { ctrl.cancel(); }, $scope);
		ctrl.activeTab = 0;
		const productsPromise = loadProducts();
		const chargesPromise = loadCharges();

		Promise.all([productsPromise, chargesPromise]).then(() => {
			ctrl.allBusinessProducts.forEach(p => {
				p.Name = `${p.Name} ($${p.Price}/${p.Unit})`;
				delete p.Id;
			
				(p.Fees ?? []).forEach(f => {
					const fullFee = ctrl.allBusinessCharges.find(c => c.Code === f.Fee.Code);

					f.Fee = {
						...f.Fee,
						...fullFee
					};
				});
			});
			ctrl.selectedProduct = ctrl.allBusinessProducts[0];

			runWhenValidBox(() => {
				const selectionChoices = uiHelpers.setDisplay(
					ctrl.allBusinessProducts, 
					{ 
						recentlyUsedEnabled: false, 
						hideCode: true 
					}
				);

				ctrl.productBox.setChoices(selectionChoices, "value", "label", true);
			});
		});
	};

	ctrl.setCurrentProduct = (value) => {
		const item = ctrl.allBusinessProducts.find(i => i.Code === value);

		ctrl.selectedProduct = item;
		
		runWhenValidBox(() => ctrl.productBox.setValueByChoice(ctrl.selectedProduct.Code));
	};

	ctrl.onOk = async() => {
		if(!validate()) {
			return;
		}

		const fees = ctrl.allBusinessCharges
			.filter(c => c.isSelected)
			.map(c => ({ 
				Fee: {
					Code: c.Code
				} 
			}));

		const payload = ctrl.activeTab === 0 ?
			{
				item: {
					name: ctrl.Item?.Name,
					price: ctrl.Price
				},
				fees
			} :
			{
				product: {
					code: ctrl.selectedProduct?.Code, 
					quantity: ctrl.Quantity
				}
			};

		const result = await loadingService.watch(ctrl.resolve.save(payload));
		ctrl.modalInstance.close(result);
	};

	ctrl.cancel = () => {
		ctrl.modalInstance.dismiss();
	};

	function validate() {
		const validationStrings = [];

		if(ctrl.activeTab === 0) {
			if(isStringNullishOrEmpty(ctrl.Item.Name)) {
				validationStrings.push("Product name is required.");
			}

			if(isStringNullishOrEmpty(ctrl.Price?.toString())) {
				validationStrings.push("Product price is required.");
			}
		}
		else {
			if(isStringNullishOrEmpty(ctrl.selectedProduct.Name)) {
				validationStrings.push("Product name is required.");
			}

			if(isStringNullishOrEmpty(ctrl.selectedProduct.Price?.toString())) {
				validationStrings.push("Product price is required.");
			}

			if(isStringNullishOrEmpty(ctrl.selectedProduct.Unit)) {
				validationStrings.push("Product unit is required.");
			}
		}

		if(validationStrings.length > 0) {
			const errorList = `<ul><li>${validationStrings.join("</li><li>")}</li></ul>`;
			
			swal({
				title: "Missing required fields",
				html: 
					`<p>Please correct the following errors</p>
					${errorList}
					`,
				showCloseButton: true,
				type: "warning"
			});
			
			return false;
		}

		return true;
	}

	ctrl.setProductBox = (box) => {
		ctrl.productBox = box;

		if(ctrl.productBox) {
			ctrl.runOnReady.forEach(func => func());
			ctrl.runOnReady = [];
		}
	};

	ctrl.setDisplay = (code) => {
		const item = ctrl.allBusinessProducts.find(i => i.Code === code);

		if(!item) {
			$logger.warn("Selected item not found as an option.");
		}

		return item.Name;
	};

	function runWhenValidBox(func) {
		if(ctrl.productBox) {
			func();
		}
		else {
			ctrl.runOnReady.push(func);
		}
	}

	async function loadProducts() {
		ctrl.allBusinessProducts = ctrl.resolve.allProducts && [...ctrl.resolve.allProducts];

		if(ctrl.allBusinessProducts === undefined) {
			if(ctrl.resolve.businessId === undefined) {
				$logger.error("the business customer transaction modal requires either available products or a business ID");
				ctrl.allBusinessProducts = [];

				return ctrl.allBusinessProducts;
			}
		
			ctrl.allBusinessProducts = await loadingService.watch(api.get(FORM_BUSINESS_PRODUCTS(appState.forms.selected.Id, ctrl.resolve.businessId)));
		}
		
		return ctrl.allBusinessProducts;
	}
	
	async function loadCharges() {
		ctrl.allBusinessCharges = ctrl.resolve.charges && [...ctrl.resolve.charges];

		if(ctrl.allBusinessCharges === undefined) {
			if(ctrl.resolve.businessId === undefined) {
				$logger.error("the business customer transaction modal requires either available charges or a business ID");
				ctrl.allBusinessCharges = [];
			
				return ctrl.allBusinessCharges;
			}
		
			ctrl.allBusinessCharges = await loadingService.watch(api.get(FORM_BUSINESS_CHARGES(appState.forms.selected.Id, ctrl.resolve.businessId)));
		}
		return ctrl.allBusinessCharges;
	}
}

export default angular.module("vesl.components.business-customer-new-transaction-modal", [])
	.component("businessCustomerNewTransactionModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<",
			reload: "&"
		}
	})
	.name;
